import { i18n } from '@common';
const cis = require('./i18n.cis.base.en.json');
const admin = require('./i18n.cis.admin.en.json');
const student = require('./i18n.cis.student.en.json');

i18n.init('cis_base', { en: cis });
i18n.init('cis_admin', { en: admin });
i18n.init('cis_student', { en: student });

